// Relative Imports
import { Container } from "./styles";

const Splitter = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Splitter;
